import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import type { PlanTitleProps as Props } from './types';

export const PlanTitle = memo(({ className }: Props) => {
  const { isPaid } = usePlanCardContext();

  return (
    <Styled.Wrapper
      className={classnames('PlanTitle', className)}
      color={isPaid ? 'common.white' : 'common.black'}
      fontWeight={700}
      variant="body2"
      mt={1}
      mb={1}
    >
      {isPaid ? 'Usage-Based Plan' : 'Free Plan'}
    </Styled.Wrapper>
  );
});

PlanTitle.displayName = 'PlanTitle';
